// extracted by mini-css-extract-plugin
export default {"section":"NavigationAside__section--slots-ErlSE","nav":"NavigationAside__nav--slots-CvNAp"};